import React, { FC } from 'react';
import { graphql } from 'gatsby';

import H1 from '@bitcoin-portal/bitcoincom-pkg-components/dist/H1';
import Paragraph from '@bitcoin-portal/bitcoincom-pkg-components/dist/Paragraph';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';

import {
  Heading,
  StyledContentBlock,
  StyledSection,
  WidgetWrapper,
} from './styled';
import WidgetV2 from '../../../components/WidgetV2';
import Image from '../../../components/Image';

interface Props {
  crypto?: string;
  provider?: string;
}

const Header: FC<Props & Queries.SeoHeaderFragment> = ({
  header,
  crypto,
  provider,
}) => {
  const { title, image } = header || {};

  return (
    <StyledSection>
      <Heading>
        <H1>Buy Bitcoin</H1>
        <Paragraph style={{ maxWidth: 'unset' }}>
          Buy, sell, trade, and invest in Bitcoin & crypto - all in one app.
          Cryptocurrencies are volatile, and investing may result in the loss of
          your entire capital. This financial promotion has been approved by
          Gateway 21 on 9th April 2025
        </Paragraph>
      </Heading>

      <StyledContentBlock
        flip={ContentBlock.Flips.Horizontal}
        aside={
          <Image
            image={image}
            alt={title}
            width="450px"
            imgStyle={{ margin: 'auto' }}
          />
        }
      >
        <WidgetWrapper>
          <WidgetV2 crypto={crypto} provider={provider} />
        </WidgetWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment SeoHeader on Json {
    header {
      title
      subtitle
      image {
        childImageSharp {
          gatsbyImageData(width: 450, placeholder: NONE)
        }
      }
      media {
        childImageSharp {
          gatsbyImageData(placeholder: NONE)
        }
      }
    }
  }
`;

export default Header;
